'use client'

import CloseIcon from '@trustoo/components/ui/icon/CloseIcon'
import { ButtonHTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

/**
 * Dialog.CloseButton - the close affordance
 *
 * **Role in Compound Structure:**
 * A presentational button. It does not close the dialog on its own — wire `onClick` to your
 * close handler (typically the same `onClose` you pass to `Dialog.Root`).
 *
 * **Responsibilities:**
 * - Renders the grey close icon in the top-right corner, darkening on hover.
 *   Override the colour by passing e.g. `text-[#10185a]` via `className` — `twMerge` lets it win
 *   over the default `text-[#dadada]` without `!important`. Swap the glyph via `children`.
 * - Forwards all native button props (including `onClick`)
 */
const DialogCloseButton = ({
    className,
    children,
    ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button
        type="button"
        className={twMerge(
            'absolute right-0 top-0 z-[1] cursor-pointer p-2.5 text-[#dadada] transition-colors hover:text-black focus-visible:outline-none',
            className,
        )}
        {...rest}>
        {children ?? <CloseIcon size={24} />}
    </button>
)

export default DialogCloseButton
